'use strict';

import React from 'react';
import MediaActions from 'actions/MediaActions';
import LocationStore from 'stores/LocationStore';
import LocationActions from 'actions/LocationActions';
import API from 'sources/API';
import {Link, browserHistory} from 'react-router';
import 'styles/Location.scss';

class LocationComponent extends React.Component {
  constructor(props) {
    super(props);
    let locationStore = LocationStore.getState();
    this.state = {
      locations: locationStore.locations, // 当前可选择的所有位置
      continent: locationStore.continent, // 当前选中的洲
      country: locationStore.country, // 当前选中的国家
      state: locationStore.state, // 当前选中的省
      city: locationStore.city,  // 当前选中的城市
      showList: this.props.showList,    // 是否显示选择列表
      showLocation: locationStore.location||{_id: '0000', name: '小地球', type:'world', image: ''},  // 当前展示的 Location
      moreLocationsShow: false,
      needRefresh: locationStore.needRefresh
    };
    this.pickLocation = this.pickLocation.bind(this); // 选中某个位置
    this.openLocationList = this.openLocationList.bind(this); // 打开选择列表
    this.onLocationChange = this.onLocationChange.bind(this); // 数据有变
    this.gotoPublish = this.gotoPublish.bind(this); // 数据有变
  }
  componentDidMount() {
    if(this.props.isExplore !== false) {
      if(this.state.city) {
        this.state.showList = false;
        if(this.state.needRefresh){
          MediaActions.updateLocationId(this.state.city._id, 'city');
        }
        MediaActions.updateLocationId(this.state.city._id, 'city');
      } else if(this.state.state) {
        if(this.state.needRefresh){
          MediaActions.updateLocationId(this.state.state._id, 'state');
        }
        LocationActions.fetchLocationList(this.state.state);
      } else if(this.state.country) {
        if(this.state.needRefresh){
          MediaActions.updateLocationId(this.state.country._id, 'country');
        }
        LocationActions.fetchLocationList(this.state.country);
      } else if(this.state.continent) {
        if(this.state.continent.type === 'continent') {
          if(this.state.needRefresh){
            MediaActions.updateLocationId(this.state.continent._id, 'continent');
          }
          LocationActions.fetchLocationList(this.state.continent);
        } else {
          LocationActions.fetchLocationList({name:'小地球', type:'world', image: '', _id: 0}); // 请求所有洲信息
        }
      } else {
        LocationActions.fetchLocationList({name:'小地球', type:'world', image: '', _id: 0}); // 请求所有洲信息
      }
    }
    LocationStore.listen(this.onLocationChange);
  }
  componentWillUnmount() {
    LocationStore.unlisten(this.onLocationChange);
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.isExplore === false) { // 必须判断 false，因为可能是null
      let location = {
        continent: nextProps.continent, // 当前选中的洲
        country: nextProps.country, // 当前选中的国家
        state: nextProps.state, // 当前选中的省
        city: nextProps.city  // 当前选中的城市
      };
      if(location.continent) location.continent.type = 'continent';
      if(location.country) location.country.type = 'country';
      if(location.state) location.state.type = 'state';
      if(location.city) location.city.type = 'city';
      this.setState(location);
      this.setState({showList: nextProps.showList});
    }
  }
  onLocationChange(state) {
    this.setState({
      locations: state.locations,
      continent: state.continent, // 当前选中的洲
      country: state.country, // 当前选中的国家
      state: state.state, // 当前选中的省
      city: state.city,  // 当前选中的城市
      needRefresh: state.needRefresh
    });
  }
  openLocationList(location) {  // 根据点击的位置类型弹出相应选择列表
    let type = location.type; // 点击的位置类型
    if(this.props.isExplore === false) {
      LocationActions.updateLocation(location);
      LocationActions.updateLocations(null);
      LocationActions.updateRefreshTag('1')
      
      if(type === 'continent') {
        LocationActions.updateContinent(this.state.continent);
        LocationActions.updateCountry(null);
        LocationActions.updateState(null);
        LocationActions.updateCity(null);
      } else if(type === 'country') {
        LocationActions.updateContinent(this.state.continent);
        LocationActions.updateCountry(this.state.country);
        LocationActions.updateState(null);
        LocationActions.updateCity(null);
      } else if(type === 'state') {
        LocationActions.updateContinent(this.state.continent);
        LocationActions.updateCountry(this.state.country);
        LocationActions.updateState(this.state.state);
        LocationActions.updateCity(null);
      } else if(type === 'city') {
        LocationActions.updateContinent(this.state.continent);
        LocationActions.updateCountry(this.state.country);
        LocationActions.updateState(this.state.state);
        LocationActions.updateCity(this.state.city);
      }

      // browserHistory.push(`/medias?type=${type}&id=${location._id}`);
      browserHistory.push(`/medias`);
      return;
    }

    if(location === this.state.showLocation || (type === 'world' && this.state.showLocation.type === 'world')){
      this.setState({showList:!this.state.showList});
      return;
    }

    if(type === 'world') {  // 第一次点击世界
      this.setState({
        showList: true,
        location: null
      });
    } else if(type === 'continent') { // 点击已经选中的洲
      this.setState({
        country: null,
        state: null,
        city: null,
        showList: true,
        location: null
      });
    } else if(type === 'country') { // 点击已经选中的国家
      this.setState({
        state: null,
        city: null,
        showList: true,
        location: null
      });
    } else if(type === 'state') { // 点击已经选中的省
      this.setState({
        city: null,
        showList: true,
        location: null
      });
    }
    
    this.setState({showLocation:location});
    LocationActions.updateLocation(location);
    LocationActions.fetchLocationList(location);
  }
  gotoPublish(event){
    event.preventDefault();
    let check = API.checkToken;
    if(check){
      browserHistory.push('/publish');
    }
  }
  pickLocation(location) { // 选中某个位置
    if(location.type !== 'more') {
      this.setState({moreLocationsShow: false});
    }
    switch(location.type) {
      case 'world':
        this.setState({
          locations: null,
          continent: null,
          country: null,
          state: null,
          city: null,
          showList: false
        });
        LocationActions.updateLocation(location);
        // 更新当前选中地址的子项
        LocationActions.updateLocations(null);
        // 根据 LocationID 更新 MediaList
        MediaActions.updateLocationId(location._id, location.type);
        // 更新 explore 页面分享标记
        MediaActions.updateShareTag();
        // 获取下一层级的地址
        LocationActions.fetchLocationList({name:'小地球', type:'world', image: '', _id: 0});  // 获取location下一层级的地址信息
        // 更新当前显示location
        this.setState({showLocation:location});
        break;
      case 'more':
        LocationActions.updateLocation(location);
        browserHistory.push(`/location`);
        break;
      default:
        let newState; // 关闭选择列表
        switch(location.type) {
          case 'world':
            newState = {
              locations: null, // 当前子列表
              continent: null, // 当前选中的洲
              country: null, // 当前选中的国家
              state: null, // 当前选中的省
              city: null  // 当前选中的城市
            };
            break;
          case 'continent':
            newState = {
              locations: null, // 当前子列表
              continent: location, // 当前选中的洲
              country: null, // 当前选中的国家
              state: null, // 当前选中的省
              city: null  // 当前选中的城市
            };
            break;
          case 'country':
            newState = {
              locations: null, // 当前子列表
              country: location, // 当前选中的国家
              state: null, // 当前选中的省
              city: null  // 当前选中的城市
            };
            break;
          case 'state':
            newState = {
              locations: null, // 当前子列表
              state: location, // 当前选中的省
              city: null  // 当前选中的城市
            }
            break;
          case 'city': {
            newState = {
              locations: null, // 当前子列表
              city: location
            };
          }
          default:
            break;
        }
        newState.showList = false;
        this.setState(newState);
        // 根据 LocationID 更新 MediaList
        MediaActions.updateLocationId(location._id, location.type);
        // 更新 explore 页面分享标记
        MediaActions.updateShareTag();
        // 保存当前选中的地址
        LocationActions.updateLocation(location);
        // 更新当前选中地址的子项
        LocationActions.updateLocations(null);
        this.setState({showLocation:location});
        
        // 获取下一层级的地址
        if(location.type !== 'city') {
          LocationActions.fetchLocationList(location);  // 获取location下一层级的地址信息
        }
    }
  }
  render() {
    let locationList, locationListWrapper, currentContinent, currentCountry, currentState, currentCity;
    if(this.state.showList && this.state.locations) {
      locationList = this.state.locations.map((location) =>
        <div key={location._id} className="small-3 columns" onClick={this.pickLocation.bind(this, location)}>
          <img src={location.image} className={location.image?'':`color-${parseInt(location._id.slice(-4), 16)%19} pattern-${parseInt(location._id.slice(-4), 16)%10}`} />
          <div className="name">{location.name}</div>
        </div>
      );

      locationListWrapper = (
        <div className="location-list expanded row">
          {locationList}
        </div>
      );
    }
    if(this.state.continent) {
      currentContinent = <li><a href="javascript:void(0);" onClick={this.openLocationList.bind(this, this.state.continent)}>{this.state.continent.name}</a></li>
    }
    if(this.state.country) {
      currentCountry = <li><a href="javascript:void(0);" onClick={this.openLocationList.bind(this, this.state.country)}>{this.state.country.name}</a></li>
    }
    if(this.state.state) {
      currentState = <li><a href="javascript:void(0);" onClick={this.openLocationList.bind(this, this.state.state)}>{this.state.state.name}</a></li>
    }
    if(this.state.city) {
      currentCity = <li><a href="javascript:void(0);" onClick={this.openLocationList.bind(this, this.state.city)}>{this.state.city.name}</a></li>
    }
    let nav = (
      <nav className="location-nav expanded row" aria-label="You are here:" role="navigation">
        <ul className={`breadcrumbs columns pull-left ${this.props.isExplore?"mx-explore":''}`}>
          <li><a href="javascript:void(0);" onClick={this.openLocationList.bind(this, {_id: '0000', name: '小地球', type:'world', image: ''})}>小地球</a></li>
          {currentContinent}
          {currentCountry}
          {currentState}
          {currentCity}
        </ul>
        {this.props.isExplore?(<a onClick={this.gotoPublish} className="publish-btn"><i className="fa fa-camera fa-2"></i></a>):''}
      </nav>
    );
    return (
      <div className="location-component">
        {nav}
        {locationListWrapper}
      </div>
    );
  }
}

LocationComponent.displayName = 'LocationComponent';

export default LocationComponent;


// WEBPACK FOOTER //
// ./src/components/LocationComponent.js